module.exports = __webpack_public_path__ + "img/banner.ffbf4e5.webp";